import React from 'react';
import { ChevronDown } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQ = () => {
  const { t } = useTranslation();

  // Array delle chiavi delle FAQ (ho 10 FAQ nel JSON)
  const faqItems = [
    { questionKey: 'q1', answerKey: 'a1' },
    { questionKey: 'q2', answerKey: 'a2' },
    { questionKey: 'q3', answerKey: 'a3' },
    { questionKey: 'q4', answerKey: 'a4' },
    { questionKey: 'q5', answerKey: 'a5' },
    { questionKey: 'q6', answerKey: 'a6' },
    { questionKey: 'q7', answerKey: 'a7' },
    { questionKey: 'q8', answerKey: 'a8' },
    { questionKey: 'q9', answerKey: 'a9' },
    { questionKey: 'q10', answerKey: 'a10' }
  ];

  return (
    <section id="faq" className="py-20 bg-gradient-to-br from-purple-50 to-pink-50">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t('faq.title')}
          </h2>
          <p className="text-xl text-gray-600">
            {t('faq.subtitle')}
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqItems.map((item, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow border-0 px-6"
              >
                <AccordionTrigger className="text-left font-semibold text-gray-900 hover:text-pink-600 py-5 hover:no-underline">
                  {t(`faq.${item.questionKey}`)}
                </AccordionTrigger>
                <AccordionContent className="text-gray-600 leading-relaxed pb-5">
                  {t(`faq.${item.answerKey}`)}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
